import "./App.css";
import "./assets/scss/global.scss";
import "./assets/scss/slick.scss";
// import "./assets/scss/responsive.scss";
import "./assets/css/responsive.css";
import "./assets/css/style.css";
// import "./assets/scss/slicktheme.scss";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Home from "./routes/home";
import Login from "./routes/login";
import Signup from "./views/loginSignup/Signup";
import { Subscription } from "./routes/subscription";
import { SubscriptionSuccess } from "./routes/subscriptionSuccess";
import { SubscriptionFailure } from "./routes/subscriptionFailure";
import { Privacy } from "./routes/privacy";
import { TermsCondition } from "./routes/termscondition";
import CreateAccount from "./routes/createAccount";
import ManagePatient from "./routes/managePatient";
import PatientInformation from "./routes/patientInformation";
import PatientMedicineInformation from "./routes/patientMedicineInformation";
import PatientReportInformation from "./routes/patientReportInformation";
import ProtectedRoute from "./routes/PrivateRoute";
import AboutUs from "./routes/about";
import Services from "./routes/Services";
import ContactUs from "./routes/ContactUs";
import ClinicalIntakeForm from "./routes/ClinicalIntakeForm";
import 'bootstrap/dist/css/bootstrap.min.css';
import { TwoStepAuthentication } from "./routes/twoStepAuthentication";
import ScrollToTop from "./components/pages/ScrollToTop";
import NotFound from "./components/pages/NotFound";
import ClinicalIntakeFormNew from "./routes/ClinicalIntakeFormNew";
// import { ADMINHOME, ADMINPROMPTPAGE, ADMINPROMPTSADD, ADMINPROMPTSEDIT, ADMINSUPPORTPAGE, CLIENT_INTAKE_FORM_URL, DOCTORASSESMENTINFORMATIONPAGE, PATIENTASSESMENTINFORMATIONPAGE, PATIENTEPORTINFORMATION, PATIENTRELATIVESINFORMATION, RELATIVE_INTAKE_FORM_URL, RELATIVE_INTAKE_SUBMIT_URL, RELATIVEFROMDETAIL } from "./util/path";
// import { ADMINHOME, ADMINPROMPTPAGE, ADMINPROMPTSADD, ADMINPROMPTSEDIT, ADMINSUPPORTPAGE,ADMINSUBSCRIPTIONPAGE,ADMINSUBSCRIPTIONEDIT,  CLIENT_INTAKE_FORM_URL, DOCTORASSESMENTINFORMATIONPAGE, PATIENTASSESMENTINFORMATIONPAGE, PATIENTEPORTINFORMATION, PATIENTRELATIVESINFORMATION, RELATIVE_INTAKE_FORM_URL, RELATIVE_INTAKE_SUBMIT_URL, RELATIVEFROMDETAIL, ADMINUSERCLINICIANSPAGE, ADMINCMSTESTIMONIALPAGE, ADMINCMSTESTIMONIALADD, ADMINCMSTESTIMONIALUPDATE,  } from "./util/path";
import { ADMINHOME, ADMINPROMPTPAGE, ADMINPROMPTSADD, ADMINPROMPTSEDIT, ADMINSUPPORTPAGE, ADMINSUBSCRIPTIONPAGE, ADMINSUBSCRIPTIONEDIT, CLIENT_INTAKE_FORM_URL, DOCTORASSESMENTINFORMATIONPAGE, PATIENTASSESMENTINFORMATIONPAGE, PATIENTEPORTINFORMATION, PATIENTRELATIVESINFORMATION, RELATIVE_INTAKE_FORM_URL, RELATIVE_INTAKE_SUBMIT_URL, RELATIVEFROMDETAIL, ADMINUSERCLINICIANSPAGE, ADMINCMSTESTIMONIALPAGE, ADMINCMSTESTIMONIALADD, ADMINCMSTESTIMONIALUPDATE, ADMINCMSFAQSPAGE, ADMINCMSFAQADD, ADMINCMSFAQUPDATE, ADMINCMSABOUTPAGE, ADMINCMSSERVICEPAGE, ADMINCMSPRIVACYPAGE, ADMINCMSTERMSPAGE, ADMINCONTACTUSPAGE, RECORDINGINFORMATIONPAGE, PAITENT_DETAILS, SETTINGS, ADMINTEMPLATEPAGE, ADMINTEMPLATESADD, ADMINTEMPLATESEDIT, ADMINSOCIALMEDIAPAGE, ADMINSOCIALMEDIAADD, ADMINSOCIALMEDIAUPDATE, ADMINTEMPLATEGUIDELINE } from "./util/path";
import RelaTiveIntakeFormNew from "./views/RelaTiveIntakeForm";
import PatientRelativesInformationPage from "./views/patientInformation/patientRelativesInformationPage";
import PatientRelativesInformation from "./routes/PatientRelativesInformation";
import 'sweetalert2/dist/sweetalert2.min.css';
import PatientReportInformationNew from "./routes/patientReportInformationNew";
import AdminPromptsPage from "./routes/admin/prompts";
import RelaTiveIntakeSubmitFormDetail from "./views/RelaTiveIntakeSubmitFormDetail";
import PatientRelativesSubmitDetailInformation from "./routes/PatientRelativesSubmitDetailInformation";
import { Unsubscribe } from "./routes/Unsubscribe";
import PatientAssement from "./routes/patientAssement";
import RecordingInformation from "./routes/RecordingInformation";
import PatientAssementSubmit from "./routes/patientAssementSubmit";
import PatientAssesmentSubmitPage from "./views/patientInformation/patientAssesmentSubmitPage";
import PatientReportInformationNewReactQuill from "./routes/patientReportInformationNewReactQuill";
import NetworkCheck from "./components/NetworkCheck";
import { useEffect, useState } from "react";
import Faq from "./routes/faq";
import CookiesPolicy from "./views/cookiesPolicy/cookiesPolicy";
import ForgetPassword from "./views/ForgetPassword/ForgetPassword";
import ResetPassword from "./views/ResetPassword/ResetPassword";
import AdminPromptsPageList from "./routes/admin/prompts/list";
import AdminSupportRequestList from "./routes/admin/support";
import ConnectSupport from "./views/connectSupport/connectSupport";
import AdminUserCliniciansPageList from "./routes/admin/Users/list";
import AdminSubscriptionList from "./routes/admin/subscription/list";
import AdminSubscriptionPageEdit from "./routes/admin/subscription";
import AdminTestimonialUpdatePage from "./routes/admin/Cms/Testimonial/AdminTestimonialUpdatePage";
import AdminTestimonialAddPage from "./routes/admin/Cms/Testimonial/AdminTestimonialAddPage";
import AdminTestimonialPageList from "./routes/admin/Cms/Testimonial/AdminTestimonialPageList";
import AdminFaqPageList from "./routes/admin/Cms/Faq/AdminFaqPageList";
import AdminFaqAddPage from "./routes/admin/Cms/Faq/AdminFaqAddPage";
import AdminFaqUpdatePage from "./routes/admin/Cms/Faq/AdminFaqUpdatePage";

import AdminAboutPage from "./routes/admin/Cms/AdminAboutPage";
import AdminServicePage from "./routes/admin/Cms/AdminServicePage";
import AdminPrivacyPolicyPage from "./routes/admin/Cms/AdminPrivacyPolicyPage";
import AdminTermsConditionPage from "./routes/admin/Cms/AdminTermsConditionPage";
import AdminContactUsPageList from "./routes/admin/Cms/AdminContactUsPageList";
import PatientInformationDetails from "../src/views/patientInformation/paitentInformationDetails";
import Settings from "./views/patientInformation/Settings";
import AdminTemplatePageList from "./routes/admin/template/list";
import AdminTemplatePage from "./routes/admin/template";
import PatientReportInformationPageReactQuillTemplate from "./views/patientInformation/patientReportInformationPageNewReactQuillTemplateWise";
import ManagePaitentIntakeForm from "./views/paitentIntakeManage/managePatientIntakeFormPage";
import AddPaitentIntakeForm from "./views/AddPaitentIntakeForm";
import ChangePassword from "./routes/changePassword";
import AdminSocialMediaPage from "./routes/admin/Cms/SocialMedia/AdminSocialMediaPage";
import AdminSocialMediaAddPage from "./routes/admin/Cms/SocialMedia/AdminSocialMediaAddPage";
import AdminSocialMediaUpdatePage from "./routes/admin/Cms/SocialMedia/AdminSocialMediaUpdatePage";
import AdminTemplatePageGuideline from "./views/admin/template/guideline";
import PatientReportInformationPageTemplateClaude from "./views/patientInformation/patientReportInformationPageTemplateClaude";

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const checkNetworkStatus = () => {
    const onlineStatus = navigator.onLine;
    setIsOnline(onlineStatus);
    if (!onlineStatus) {
      navigate('/no-network');
    }
  };

  useEffect(() => {
    checkNetworkStatus();
    const intervalId = setInterval(checkNetworkStatus, 6000);
    return () => clearInterval(intervalId);
  }, [navigate]);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/create-account" element={<ProtectedRoute><CreateAccount /></ProtectedRoute>} />
        <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
        <Route path="/manage-patient" element={<ProtectedRoute><ManagePatient /></ProtectedRoute>} />
        <Route path="/patient-information" element={<ProtectedRoute><PatientInformation /></ProtectedRoute>} />
        <Route path="/two-step-authentication" element={<ProtectedRoute><TwoStepAuthentication /></ProtectedRoute>} />
        <Route path="/unsubscribe" element={<ProtectedRoute><Unsubscribe /></ProtectedRoute>} />

        <Route path="/patient-report-information/:id" element={<ProtectedRoute><PatientReportInformationNewReactQuill /></ProtectedRoute>} />
        <Route path="/patient-report-information-template/:id" element={<ProtectedRoute><PatientReportInformationPageReactQuillTemplate /></ProtectedRoute>} />\
        <Route path="/patient-report-information-template-claude/:id" element={<ProtectedRoute><PatientReportInformationPageTemplateClaude /></ProtectedRoute>} />

        {/* <Route path={`${PATIENTEPORTINFORMATION}/:id`} element={<ProtectedRoute><PatientReportInformationNewReactQuill /></ProtectedRoute>} /> */}
        {/* <Route path='/patient-report-information-new/:id' element={<ProtectedRoute><PatientReportInformationNew /></ProtectedRoute>} /> */}

        <Route path={`${PATIENTRELATIVESINFORMATION}/:id`} element={<ProtectedRoute><PatientRelativesInformation /></ProtectedRoute>} />
        <Route path={`${RELATIVE_INTAKE_SUBMIT_URL}/:id`} element={<ProtectedRoute><PatientRelativesSubmitDetailInformation /></ProtectedRoute>} />

        <Route path={`${DOCTORASSESMENTINFORMATIONPAGE}/:id`} element={<ProtectedRoute><PatientAssement /></ProtectedRoute>} />
        <Route path={`${RECORDINGINFORMATIONPAGE}/:id`} element={<ProtectedRoute><RecordingInformation /></ProtectedRoute>} />

        <Route path={`${PATIENTASSESMENTINFORMATIONPAGE}`} element={<PatientAssesmentSubmitPage />} />

        <Route path="/subscription" element={<Subscription />} />
        <Route path="/subscription-success" element={<SubscriptionSuccess />} />
        <Route path="/subscription-failure" element={<SubscriptionFailure />} />
        <Route path="/terms-condition" element={<TermsCondition />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        {/* <Route path="/clinical-intake-form" element={<ClinicalIntakeForm />} /> */}
        <Route path="/clinical-intake-form" element={<ClinicalIntakeFormNew />} />

        <Route path={`${CLIENT_INTAKE_FORM_URL}`} element={<ClinicalIntakeFormNew />} />
        <Route path={`${RELATIVE_INTAKE_FORM_URL}`} element={<RelaTiveIntakeFormNew />} />
        <Route path={`/paitent-intake-manage/:id`} element={<ManagePaitentIntakeForm />} />
        <Route path={`/add-paitent-intake/:id`} element={<AddPaitentIntakeForm />} />

        <Route path={`${RELATIVEFROMDETAIL}`} element={<RelaTiveIntakeSubmitFormDetail />} />


        {/* Admin routes Starts here */}
        <Route path={`${ADMINPROMPTPAGE}`} element={<ProtectedRoute><AdminPromptsPageList /></ProtectedRoute>} />
        <Route path={`${ADMINPROMPTSADD}`} element={<ProtectedRoute><AdminPromptsPage /></ProtectedRoute>} />
        <Route path={`${ADMINPROMPTSEDIT}/:id`} element={<ProtectedRoute><AdminPromptsPage /></ProtectedRoute>} />

        <Route path={`${ADMINTEMPLATEPAGE}`} element={<ProtectedRoute><AdminTemplatePageList /></ProtectedRoute>} />
        <Route path={`${ADMINTEMPLATESADD}`} element={<ProtectedRoute><AdminTemplatePage /></ProtectedRoute>} />
        <Route path={`${ADMINTEMPLATESEDIT}/:id`} element={<ProtectedRoute><AdminTemplatePage /></ProtectedRoute>} />
        <Route path={`${ADMINTEMPLATEGUIDELINE}/:id`} element={<ProtectedRoute><AdminTemplatePageGuideline /></ProtectedRoute>} />

        <Route path={`${ADMINSUPPORTPAGE}`} element={<ProtectedRoute><AdminSupportRequestList /></ProtectedRoute>} />
        <Route path={`${ADMINUSERCLINICIANSPAGE}`} element={<ProtectedRoute><AdminUserCliniciansPageList /></ProtectedRoute>} />
        <Route path={`${ADMINSUBSCRIPTIONPAGE}`} element={<ProtectedRoute><AdminSubscriptionList /></ProtectedRoute>} />
        <Route path={`${ADMINSUBSCRIPTIONEDIT}/:id`} element={<ProtectedRoute><AdminSubscriptionPageEdit /></ProtectedRoute>} />

        <Route path={`${ADMINCMSTESTIMONIALPAGE}`} element={<ProtectedRoute><AdminTestimonialPageList /></ProtectedRoute>} />
        <Route path={`${ADMINCMSTESTIMONIALADD}`} element={<ProtectedRoute><AdminTestimonialAddPage /></ProtectedRoute>} />
        <Route path={`${ADMINCMSTESTIMONIALUPDATE}/:id`} element={<ProtectedRoute><AdminTestimonialUpdatePage /></ProtectedRoute>} />

        <Route path={`${ADMINCMSFAQSPAGE}`} element={<ProtectedRoute><AdminFaqPageList /></ProtectedRoute>} />
        <Route path={`${ADMINCMSFAQADD}`} element={<ProtectedRoute><AdminFaqAddPage /></ProtectedRoute>} />
        <Route path={`${ADMINCMSFAQUPDATE}/:id`} element={<ProtectedRoute><AdminFaqUpdatePage /></ProtectedRoute>} />
        <Route path={`${ADMINCMSABOUTPAGE}`} element={<ProtectedRoute><AdminAboutPage /></ProtectedRoute>} />
        <Route path={`${ADMINCMSSERVICEPAGE}`} element={<ProtectedRoute><AdminServicePage /></ProtectedRoute>} />
        <Route path={`${ADMINCMSPRIVACYPAGE}`} element={<ProtectedRoute><AdminPrivacyPolicyPage /></ProtectedRoute>} />
        <Route path={`${ADMINCMSTERMSPAGE}`} element={<ProtectedRoute><AdminTermsConditionPage /></ProtectedRoute>} />
        <Route path={`${ADMINCONTACTUSPAGE}`} element={<ProtectedRoute><AdminContactUsPageList /></ProtectedRoute>} />
        <Route path={`${ADMINSOCIALMEDIAPAGE}`} element={<ProtectedRoute><AdminSocialMediaPage /></ProtectedRoute>} />
        <Route path={`${ADMINSOCIALMEDIAADD}`} element={<ProtectedRoute><AdminSocialMediaAddPage /></ProtectedRoute>} />
        <Route path={`${ADMINSOCIALMEDIAUPDATE}/:id`} element={<ProtectedRoute><AdminSocialMediaUpdatePage /></ProtectedRoute>} />

        <Route path={`${PAITENT_DETAILS}`} element={<PatientInformationDetails />} />
        <Route path={`${SETTINGS}`} element={<Settings />} />


        <Route path="/no-network" element={<NetworkCheck />} />
        {/* End admin routes here */}

        <Route path="faq" element={<Faq />} />
        <Route path="cookies-policy" element={<CookiesPolicy />} />
        <Route path="support-request" element={<ProtectedRoute><ConnectSupport /></ProtectedRoute>} />

        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />



        <Route path="*" element={<NotFound />} />


      </Routes>
    </>
  );
}

export default App;
